import ProjectSession from "../../../model2/project/project-session"
import {SelectParent_SectionType} from "../@const"
import {selectParent_filter, selectParent_searchAndFilter} from "./filter"
import {SpaceProto} from "../../../model2/space/space-proto"
import ProjectSessionCollection from "../../../model2/project/collection"
import {EntityType} from "../../../gd/const/item"

// const debug = 'selectParent_getProjects'
const debug = false

export const selectParent_getProjects = (currentSection?:SelectParent_SectionType | SpaceProto, params?: {
    availableProjects?  : ProjectSessionCollection
    searchString?       : string
    parentsFor?         : EntityType | EntityType[]
}) => {

    let projects: ProjectSession[] = []

    let parentsFor: EntityType[] | undefined = undefined
    if (params?.parentsFor) {
        // ensure parentsFor is always an array
        parentsFor = Array.isArray(params.parentsFor)
            ? params.parentsFor
            : [params.parentsFor]
    }

    if (currentSection) {
        switch (currentSection) {
            case SelectParent_SectionType.STARRED:
                projects = gd.session.starredItems.starredProjects
                selectParent_filter(projects, parentsFor, params?.availableProjects)
                break

            case SelectParent_SectionType.PINNED:
                const projectsCollection = params?.availableProjects || gd.session.projects
                projects = gd.session.pins.getSessionProjects(projectsCollection)
                selectParent_filter(projects, parentsFor, params?.availableProjects)
                break

            case SelectParent_SectionType.SEARCH:
                debug && console.log(debug, 'process [', params?.searchString, ']', parentsFor, params?.availableProjects)

                if (parentsFor) {
                    projects = selectParent_searchAndFilter(params?.searchString!, parentsFor, params?.availableProjects)
                } else {
                    console.warn('selectParent_getProjects: "parentsFor" is required for search')
                }
                break

            default:
                projects = (currentSection as SpaceProto).rootProjects
                selectParent_filter(projects, parentsFor, params?.availableProjects)
                break
        }
    }

    debug && console.log(debug, 'process projects', projects)

    return projects
}